import {initDetailsAccordion} from '../modules/details-accordion.js';

initDetailsAccordion({
  item: '.access__accordion',
  summary: '.access__accordion-summary',
  content: '.access__accordion-wrap',
});
